import { IChartSeries } from '@mais-retorno-front/models/chart-serie';
import {  IAssetQuotes } from '../interfaces';

export const createSheetFundNetWorthSerieChart = (
  fundQuotes: IAssetQuotes,
  applicationValueColor = '#0F132A'
): IChartSeries[] => {
  if (!fundQuotes) return;

  const serie = fundQuotes.quotes.map(({ d, c, p }) => ({
    date: d,
    quote: c,
    netWorth: p,
  }));

  const assetsChartData = [];

  const netWorthData = {
    data: [],
    type: 'area',
    name: 'Patrimônio liquido',
    fillOpacity: 0.2,
    color: fundQuotes.color,
  };

  const investedData = {
    data: [],
    type: 'area',
    name: 'Valor aplicado',
    fillOpacity: 0.2,
    color: applicationValueColor,
  };

  let lastQuotation = null;
  let investedMoney = 0.0;

  for (const currentQuotation of serie) {
    const period = currentQuotation.date;

    if (!lastQuotation) {
      lastQuotation = currentQuotation;
      investedMoney = currentQuotation.netWorth;
    } else {
      investedMoney +=
        (currentQuotation.netWorth / currentQuotation.quote -
          lastQuotation.netWorth / lastQuotation.quote) *
        currentQuotation.quote;
    }

    netWorthData.data.push([period, currentQuotation.netWorth || 0]);
    investedData.data.push([period, investedMoney]);

    lastQuotation = currentQuotation;
  }

  assetsChartData.push(netWorthData);
  assetsChartData.push(investedData);

  return assetsChartData;
};
